import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import InternalRouter from "./routes/Router";
import { useAppDispatch, useAppSelector } from "./hooks/redux-hooks";
import { getSEOSettings } from "./api/asyncThuncks/settings";
import { selectMainState } from "./store/slices/main";
import "./index.css";
import { TMetaTags } from "./types/settings";

function App() {
  const dispatch = useAppDispatch();
  const { SEOSettingsDefault, SEOSettings } = useAppSelector(selectMainState);
  const [metaTags, setMetaTags] = useState<TMetaTags>();
  const location = useLocation();
  const canonicalUrl = `https://radio.silpo.ua${location.pathname}`;
  const isDevHost = window.location.hostname !== "radio.silpo.ua";

  useEffect(() => {
    dispatch(getSEOSettings());
    const fetchSEOSettings = async () => {
      await dispatch(getSEOSettings());
      try {
      } catch (error) {
        console.error("Error fetching SEO settings:", error);
      }
    };
    // fetchSEOSettings();
  }, [dispatch]);

  useEffect(() => {
    if (SEOSettingsDefault) {
      setMetaTags({
        title:
          SEOSettings.appTitle?.length === 0
            ? SEOSettingsDefault.appTitle
            : SEOSettings.appTitle,
        description:
          SEOSettings.appDescription?.length === 0
            ? SEOSettingsDefault.appDescription
            : SEOSettings.appDescription,
        appImg:
          SEOSettings.appImg?.length === 0
            ? SEOSettingsDefault.appDescription
            : SEOSettings.appImg,
      });
    }
  }, [SEOSettingsDefault, SEOSettings]);

  // if (!metaTags) {
  //   return null;
  // }

  return (
    <HelmetProvider>
      <div
        data-title={metaTags?.title}
        data-description={metaTags?.description}
        data-appImg={metaTags?.appImg}
      >
        <Helmet>
          <title>{metaTags?.title}</title>
          <meta name="title" content={metaTags?.title} />
          <meta property="og:title" content={metaTags?.title} />
          <meta name="twitter:title" content={metaTags?.title} />

          <meta name="description" content={metaTags?.description} />
          <meta property="og:description" content={metaTags?.description} />
          <meta name="twitter:description" content={metaTags?.description} />

          <meta property="og:image" content={metaTags?.appImg} />
          <meta name="twitter:image" content={metaTags?.appImg} />

          <link rel="canonical" href={canonicalUrl} />
          {isDevHost && <meta name="robots" content="noindex, nofollow" />}
        </Helmet>
        <InternalRouter />
      </div>
    </HelmetProvider>
  );
}

export default App;
